// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-down.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/arrow-down'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowDownIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
